<form [formGroup]="form">
  <label class="fw-bold margin-bottom-xs" [for]="domID">
    {{ label | translate }}
  </label>
  <input type="text" class="w-100 form-control form-element" [id]="domID" [formControlName]="field" [placeholder]="placeholder" />
</form>
